import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {Store} from '@ngrx/store';
import {AppState} from '@store/app.states';
import {addCreditToContributors} from '@app/4dm1n/users-list/store/users-list.actions';

@Component({
    selector: 'app-add-credit-to-contributors',
    templateUrl: './add-credit-to-contributors.component.html',
    styleUrls: ['./add-credit-to-contributors.component.scss'],
    standalone: false
})
export class AddCreditToContributorsComponent implements OnInit {

  @Input()
  selectedUsersId: string[] = [];

  fEditExt = new UntypedFormGroup({
    amount: new UntypedFormControl(5, [Validators.required, Validators.pattern('^[0-9]*$')]),
    message: new UntypedFormControl('Merci pour votre participation - Equipe Inbe', [Validators.required]),
  });

  constructor(
    private store: Store<AppState>,
  ) {
  }

  ngOnInit(): void {
  }

  addCredits(): void {
    this.store.dispatch(addCreditToContributors({userIds: this.selectedUsersId, message: this.fEditExt.get('message').value, amount: this.fEditExt.get('amount').value}));

  }

}
